module.exports = __webpack_public_path__ + "62234b79f7b0999a69b0a32179a9d0ff.MP3";